import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=0c86c27e"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports